import React, { useState } from "react"

import "~/components/Label/Label"
import "./Dropdown.scss"
import Label from "~/components/Label/Label"

type Option = {
  optionLabel: string
  optionValue: string
}

export type DropdownProps = {
  label?: string
  options: Option[]
  value: string
  valueChanged?: (newValue: string) => void
  ariaLabel?: string
}

function Dropdown({
  label,
  options = [],
  valueChanged,
  ariaLabel,
  ...props
}: DropdownProps) {
  const [value, setValue] = useState(props.value)

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setValue(event.target.value)

    if (valueChanged) {
      valueChanged(event.target.value)
    }
  }

  return (
    <div>
      {label && <Label text={label} />}
      <select
        aria-label={ariaLabel}
        className="Dropdown__select"
        onChange={handleChange}
        value={value}
      >
        {options.map((option, index) => {
          return (
            <option value={option.optionValue} key={index}>
              {option.optionLabel}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export default Dropdown
